var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { CloseIcon } from '../../../_common/icons/index.js';
import { bookmarkModalStyles } from './styles.js';
let BookmarkEditModal = class BookmarkEditModal extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this._onDocumentKeydown = (e) => {
            e.stopPropagation();
            if (e.key === 'Enter' && !e.isComposing) {
                this._onConfirm();
            }
            if (e.key === 'Escape') {
                this.remove();
            }
        };
        this._onConfirm = () => {
            this.bookmark.page.updateBlock(this.bookmarkModel, {
                title: this.titleInput.value,
                description: this.descInput.value,
            });
            this.remove();
        };
    }
    get bookmarkModel() {
        return this.bookmark.model;
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete
            .then(() => {
            this.titleInput.focus();
            this.titleInput.setSelectionRange(0, this.titleInput.value.length);
        })
            .catch(console.error);
        this.disposables.addFromEvent(this, 'keydown', this._onDocumentKeydown);
    }
    render() {
        const title = this.bookmarkModel.title ?? this.bookmarkModel.title ?? 'Bookmark';
        return html `<div class="bookmark-modal">
      <div class="bookmark-modal-mask" @click=${() => this.remove()}></div>
      <div
        class="bookmark-modal-wrapper"
        style=${styleMap({
            height: '320px',
        })}
      >
        <icon-button
          width="32px"
          height="32px"
          class="bookmark-modal-close-button"
          @click=${() => this.remove()}
          >${CloseIcon}</icon-button
        >

        <div class="bookmark-modal-title">Edit</div>
        <div class="bookmark-modal-input-wrapper">
          <input
            type="text"
            class="bookmark-modal-input title"
            placeholder="Title"
            value=${title}
            tabindex="0"
          />
        </div>
        <div class="bookmark-modal-input-wrapper">
          <textarea
            class="bookmark-modal-input description"
            placeholder="Description"
            .value=${this.bookmarkModel.description ?? ''}
            tabindex="0"
            style=${styleMap({
            height: '104px',
        })}
          ></textarea>
        </div>
        <div class="bookmark-modal-footer">
          <div
            class="bookmark-modal-confirm-button"
            tabindex="0"
            @click=${this._onConfirm}
          >
            Save
          </div>
        </div>
      </div>
    </div>`;
    }
};
BookmarkEditModal.styles = bookmarkModalStyles;
__decorate([
    property({ attribute: false })
], BookmarkEditModal.prototype, "bookmark", void 0);
__decorate([
    query('.title')
], BookmarkEditModal.prototype, "titleInput", void 0);
__decorate([
    query('.description')
], BookmarkEditModal.prototype, "descInput", void 0);
BookmarkEditModal = __decorate([
    customElement('bookmark-edit-modal')
], BookmarkEditModal);
export { BookmarkEditModal };
export function toggleBookmarkEditModal(bookmark) {
    bookmark.host.selection.clear();
    const modal = new BookmarkEditModal();
    modal.bookmark = bookmark;
    document.body.appendChild(modal);
}
//# sourceMappingURL=bookmark-edit-modal.js.map